import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { loadCurrentOrganisation } from '@redux/directChildOrganisationAdministration/actions';
import {
  selectCurrentOrganisationState,
  selectHasParentOrganisationCapability,
} from '@redux/directChildOrganisationAdministration/selectors';

export const useParentOrganisationCapabilityBootstrap = (enabled = true) => {
  const dispatch = useDispatch();
  const currentOrganisation = useSelector(selectCurrentOrganisationState);
  const hasParentOrganisationCapability = useSelector(selectHasParentOrganisationCapability);

  useEffect(() => {
    if (enabled && currentOrganisation.status === 'idle') {
      dispatch(loadCurrentOrganisation());
    }
  }, [currentOrganisation.status, dispatch, enabled]);

  return { currentOrganisation, hasParentOrganisationCapability };
};

export const ParentOrganisationCapabilityLoading = () => {
  const { t } = useTranslation();

  return <p role="status">{t('directChildOrganisationAdministration:capability.loading')}</p>;
};
